<form class="lang-change" [formGroup]="languageForm">
    <ng-select
        [items]="languages"
        [clearable]="false"
        (change)="onLangChange($event)"
        data-test="lang-change-select"
        formControlName="lang"></ng-select>
</form>
